export class PasswordInputValidator {
    static isPasswordLongEnough(password) {
        return password.length > 6;
    }

    static passwordsMatch(password, repeatedPassword) {
        return password === repeatedPassword;
    }
}